export const LIVE_VEHICLE_REFETCH_INTERVAL = 5_000
export const LIVE_VEHICLE_STALE_TIME = 4_500
